<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

<div class="items-center md:items-start justify-center flex flex-col md:flex-row gap-4">
    <div class="pt-[5px]">
        @if (previewItems) {
            <search-info [items]="previewItems!" [searchTerm]="searchTerm"></search-info>
        }
        @if (searchParameters) {
            <div class="flex flex-wrap sm:flex-col gap-2 mt-2 w-[374px] text-slate-500">
                @for (searchParameter of searchParameters ; track searchParameter) {
                    @if (!isMobileScreen() || showAllParameters || $index < 3) {
                        <div class="p-1 rounded bg-slate-100 bg-opacity-75 text-xs font-mono text-wrap">
                            {{ searchParameter }}
                        </div>
                    }
                }
                @if (isMobileScreen() && searchParameters.length > 3) {
                    <button (click)="showAllParameters = !showAllParameters" class="text-xs bg-slate-50 rounded-sm shadow-sm p-1">
                        @if (showAllParameters) {
                            Hide Parameters
                        } @else {
                            Show All {{ searchParameters.length }} Parameters
                        }
                    </button>
                }
            </div>
        }
    </div>
    <div class="justify-center flex flex-col">
        @if (previewItems) {
            <virtual-grid [items]="previewItems!"></virtual-grid>
            @if (previewItems.items.length == 0) {
                <div class="flex flex-col gap-2 text-sm text-center pt-4">
                    <div class="text-lg font-title font-bold text-ponder">No Items Found</div>
                    <div>There are no items matching the specified search terms.</div>
                </div>
            }
        }
    </div>
</div>